import React, { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup';
import InputField from '../components/InputField/InputField'

import './styles/Register.scss'
import { registerSchema } from '../schema/schema';
import { useForm } from 'react-hook-form';
import { IRegisterInputs } from '../types/types';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import Button from '../components/Button/Button';
import { useRegister } from '../hooks/register.hook';

const Register = () => {
  const {registrate} = useRegister()
  let navigation = useNavigate()
  let auth = useAppSelector((state) => state.authReducer)
  // eslint-disable-next-line
  const { register, handleSubmit, formState:{ errors } } = useForm<IRegisterInputs>({
    resolver: yupResolver(registerSchema)
  });

  useEffect(() => {
    if(!!auth.user) navigation('/')
  }, [auth, navigation])

  const onRegister = (data: IRegisterInputs) => {
    data['avatar'] = 'https://www.seekpng.com/png/small/138-1387681_clip-art-black-and-white-stock-clip-art.png'
    registrate(data)
  }
  return (
    <main>
      <Breadcrumbs/>
      <section>
        <div className="register">
          <div className="container">
            <h1>Register an Account</h1>
            <div className="register-wrapper">
              <div className="register-account">
                <h2>Unregistred Customers</h2>
                <p>Creating an account has many benefits:</p>
                <form onSubmit={handleSubmit(onRegister)}>
                  <InputField label='Name' required type='text' {...register('name')}/>
                  <InputField label='Email' required type='email' {...register('email')}/>
                  <InputField label='Password' required type='password' {...register('password')}/>
                  <InputField label='Confirm Password' required type='password' {...register('confirmPassword')}/>
                  <div className="button-container-form">
                    <Button type='submit' variant='filled'>Register account</Button>
                  </div>
                </form>
              </div>
              <div className="register-login">
                <h2>Already have an account?</h2>
                <p>If you have an account, sign in with your email address.</p>
                <div className="button-container">
                  <Button variant='filled' action={() => navigation('/login')}>Log in to account</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Register